export const PENDING_ACTIONS_LIST = 'dashboard/LIST';
export const PENDING_ACTIONS_LIST_ASYNC = 'dashboard/LIST_ASYNC';
export const PENDING_ACTIONS_REMOVE = 'dashboard/REMOVE_FROM_LIST';

export const DASHBOARD_ROOT_URL = '/pending_actions';
